import gsap from 'gsap/gsap-core'
import EnvUtil from '../util/EnvUtil'

class GlobalNav
{
  // ---------------------------------------------------------------------------------------------------------
	// --	GlobalNav
	// ---------------------------------------------------------------------------------------------------------

  constructor(){
    //開く
    $('.header__menu-btn >a').click(this.open)
    $('.fv__menu-btn >a').click(this.open)

    //閉じる
    $('.gnav__close-btn').click(this.close)
    $('.gnav__bg').click(this.close)
  }

  open(e)
  {
    e.preventDefault();

    $('.gnav').addClass('open')
    // $('.gnav').css('display', 'block')
  }

  close(e)
  {
    e.preventDefault();

    $('.gnav').removeClass('open')

    // gsap.delayedCall(0.3, ()=>{
    //   $('.gnav').css('display', 'none')
    // })
  }
  
	// ---------------------------------------------------------------------------------------------------------
}

export default GlobalNav